var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoftwareIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.245 1.143H3.755a2.615 2.615 0 00-2.612 2.611V28.13a2.615 2.615 0 002.611 2.612h24.491a2.615 2.615 0 002.612-2.612V3.754a2.615 2.615 0 00-2.612-2.611zm-24.49 1.74h24.49c.48 0 .87.391.87.871v4.353H2.885V3.754c0-.48.39-.87.87-.87zM28.244 29H3.755c-.48 0-.871-.39-.871-.87V9.847h26.232V28.13c0 .48-.39.871-.87.871z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.954 12.53a.87.87 0 00-1.143.457l-5.223 12.188a.87.87 0 101.6.686l5.223-12.188a.87.87 0 00-.457-1.143zM11.456 15.398a.87.87 0 00-1.223-.136L5.88 18.744a.87.87 0 000 1.36l4.353 3.482a.87.87 0 001.087-1.36l-3.503-2.802 3.503-2.802a.87.87 0 00.136-1.224zM26.12 18.744l-4.353-3.482a.87.87 0 10-1.088 1.36l3.503 2.802-3.503 2.802a.87.87 0 001.088 1.36l4.352-3.482a.87.87 0 000-1.36zM5.553 6.366a.87.87 0 100-1.741.87.87 0 000 1.741zM9.035 6.366a.87.87 0 100-1.741.87.87 0 000 1.741zM12.518 6.366a.87.87 0 100-1.741.87.87 0 000 1.741zM21.223 6.366h5.223a.87.87 0 000-1.741h-5.223a.87.87 0 000 1.741z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/software-industry.2670a7e68416c2ac81fd9f1bd1401867.svg";
export { SvgSoftwareIndustry as ReactComponent };